var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-ag-grid", {
    staticClass: "intelligent-booking-table",
    attrs: {
      "grid-params": _vm.gridParams,
      "grid-options": _vm.gridOptions,
      "column-defs": _vm.columnDefs,
      "show-side-bar": true,
      "config-module": "310101",
      "row-data": _vm.rowData
    },
    on: {
      "update:gridParams": function($event) {
        _vm.gridParams = $event
      },
      "update:grid-params": function($event) {
        _vm.gridParams = $event
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }